export class LoginModel {
  constructor(username?: string,
              password?: string,
              remember?: boolean) {
    this.username = username;
    this.password = password;
    this.remember = remember;
  }
  public username: string;
  public password: string;
  public remember: boolean;
}
